<div class="main-background" fxLayout="column" fxLayoutGap="15px" *appVar="hierarchyEntity|async as entity">

    <!-- top bar -->
    <app-filter-bar
            [showNullData]="showNullData"
            [config]="billingPeriodCfg"
            [billingPeriod]="billingPeriod"
            [useFilter]="USE_FILTER"
            [showGSEBtn]="false"
            [templateIsDownloading]="templateIsDownloading"
            (billingPeriodEventEmitter)="onChangeBillingPeriod($event)">
        <!--            [response]="summary"-->
        <!--            (exportDataEventEmitter)="exportEconomicsToExcel()"-->
    </app-filter-bar>

    <!-- info section -->
    <ng-container *ngIf="entity && isViewable(entity); else unviewableEntity">
        <ng-container *ngIf="summary; else loading">
            <!--- INFO SECTION TO BE FILLED -->
        </ng-container>
    </ng-container>

    <!-- table section -->
    <div fxLayout="column" class="tile-background" *ngIf="summary && isWholeYear && !showNullData">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" class="mb-20">
            <div class="txt-h-20-7">{{ 'Payment status'|i18n }}</div>
        </div>

        <table mat-table app-table [dataSource]="summary.months" multiTemplateDataRows class="member-table">

            <!-- month -->
            <ng-container matColumnDef="month">
                <th mat-header-cell *matHeaderCellDef>
                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-h-16-5">
                        {{ 'Month'|i18n }}
                        <button app-icon-button class="sort-button ml-16"
                                (click)="onClickSortBy(SortCriterion.MONTH)"
                                [disabled]="keepYourSecrets">
                            <app-icon [name]="getSortIconName(SortCriterion.MONTH)"></app-icon>
                        </button>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div class="txt-p-14-4" fxLayoutAlign="start">
                        {{ keepYourSecrets ? '-' : monthIndexToName(row.month)|i18n }}
                    </div>
                </td>
                <th mat-header-cell *matFooterCellDef>
                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-p-18-7">
                        {{ 'Total'|i18n }}
                    </div>
                </th>
            </ng-container>

            <!-- net revenue -->
            <ng-container matColumnDef="net_revenue">
                <th mat-header-cell *matHeaderCellDef>
                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-h-16-5">
                        {{ 'Net revenue'|i18n }}
                        <button app-icon-button class="sort-button ml-16"
                                (click)="onClickSortBy(SortCriterion.NET_REVENUE)"
                                [disabled]="keepYourSecrets">
                            <app-icon [name]="getSortIconName(SortCriterion.NET_REVENUE)"></app-icon>
                        </button>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div *ngIf="showCellValue(row.month)" [ngClass]="getCellValueTextStyle(row.status)"
                         fxLayoutAlign="start">
                        {{ keepYourSecrets ? '-' : row.net_revenue|niceValue:'€':2: row.net_revenue < 0 }}
                    </div>
                    <div *ngIf="!showCellValue(row.month) && keepYourSecrets" fxLayoutAlign="start">{{ '-' }}</div>
                </td>
                <th mat-header-cell *matFooterCellDef>
                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-p-18-7">
                        {{ keepYourSecrets ? '-' : summary.net_revenue|niceValue:'€':2: summary.net_revenue < 0 }}
                    </div>
                </th>
            </ng-container>

            <!-- member absorption revenue -->
            <ng-container matColumnDef="member_absorption_revenue">
                <th mat-header-cell *matHeaderCellDef>
                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-h-16-5">
                        {{ 'Members absorption__{title}'|i18n }}
                        <button app-icon-button class="sort-button ml-16"
                                (click)="onClickSortBy(SortCriterion.MEMBER_ABSORPTION_REVENUE)"
                                [disabled]="keepYourSecrets">
                            <app-icon [name]="getSortIconName(SortCriterion.MEMBER_ABSORPTION_REVENUE)"></app-icon>
                        </button>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div *ngIf="showCellValue(row.month)" [ngClass]="getCellValueTextStyle(row.status)"
                         fxLayoutAlign="start">
                        {{ keepYourSecrets ? '-' : (row.member_absorption_revenue|niceValue:'€':2: row.member_absorption_revenue < 0) }}
                    </div>
                    <div *ngIf="!showCellValue(row.month) && keepYourSecrets" fxLayoutAlign="start">{{ '-' }}</div>
                </td>
                <th mat-header-cell *matFooterCellDef>
                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-p-18-7">
                        {{ keepYourSecrets ? '-' : summary.member_absorption_revenue|niceValue:'€':2: summary.member_absorption_revenue < 0 }}
                    </div>
                </th>
            </ng-container>

            <!-- member plant revenue -->
            <ng-container matColumnDef="member_plant_revenue">
                <th mat-header-cell *matHeaderCellDef>
                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-h-16-5">
                        {{ 'Members plant revenue'|i18n }}
                        <button app-icon-button class="sort-button ml-16"
                                (click)="onClickSortBy(SortCriterion.MEMBER_PLANT_REVENUE)"
                                [disabled]="keepYourSecrets">
                            <app-icon [name]="getSortIconName(SortCriterion.MEMBER_PLANT_REVENUE)"></app-icon>
                        </button>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div *ngIf="showCellValue(row.month)" [ngClass]="getCellValueTextStyle(row.status)"
                         fxLayoutAlign="start">
                        {{ keepYourSecrets ? '-' : (row.member_plant_revenue|niceValue:'€':2: row.member_plant_revenue < 0) }}
                    </div>
                    <div *ngIf="!showCellValue(row.month) && keepYourSecrets" fxLayoutAlign="start">{{ '-' }}</div>
                </td>
                <th mat-header-cell *matFooterCellDef>
                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-p-18-7">
                        {{ keepYourSecrets ? '-' : summary.member_plant_revenue|niceValue:'€':2: summary.member_plant_revenue < 0 }}
                    </div>
                </th>
            </ng-container>

            <!-- third party producer revenue -->
            <ng-container matColumnDef="third_party_producer_revenue">
                <th mat-header-cell *matHeaderCellDef>
                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-h-16-5">
                        {{ 'Third party producers revenue'|i18n }}
                        <button app-icon-button class="sort-button ml-16"
                                (click)="onClickSortBy(SortCriterion.THIRD_PARTY_PRODUCER_REVENUE)"
                                [disabled]="keepYourSecrets">
                            <app-icon
                                    [name]="getSortIconName(SortCriterion.THIRD_PARTY_PRODUCER_REVENUE)"></app-icon>
                        </button>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div *ngIf="showCellValue(row.month)" [ngClass]="getCellValueTextStyle(row.status)"
                         fxLayoutAlign="start">
                        {{ keepYourSecrets ? '-' : (row.third_party_producer_revenue|niceValue:'€':2: row.third_party_producer_revenue < 0) }}
                    </div>
                    <div *ngIf="!showCellValue(row.month) && keepYourSecrets" fxLayoutAlign="start">{{ '-' }}</div>
                </td>
                <th mat-header-cell *matFooterCellDef>
                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-p-18-7">
                        {{ keepYourSecrets ? '-' : summary.third_party_producer_revenue|niceValue:'€':2: summary.third_party_producer_revenue < 0 }}
                    </div>
                </th>
            </ng-container>

            <!-- status -->
            <!--<ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>
                    <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px" class="txt-h-16-5">
                        {{ 'Status_{payment}'|i18n }}
                    </div>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div *ngIf="!keepYourSecrets" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px"
                         [ngClass]="'status-' + row.status">
                        <app-icon [name]="getStatusIcon(row.status)"></app-icon>
                        <div class="txt-p-16-4">{{ row.status|ecMonthStatus }}</div>
                    </div>
                    <div *ngIf="keepYourSecrets" fxLayoutAlign="center center" class="txt-p-16-4">{{ '-' }}</div>
                </td>
                <th mat-header-cell *matFooterCellDef></th>
            </ng-container>-->

            <ng-container matColumnDef="consolidated">
                <th mat-header-cell *matHeaderCellDef>
                    <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px" class="txt-h-16-5">
                        {{ 'Situation'|i18n }}
                    </div>
                </th>
                <td mat-cell *matCellDef="let row">
                    <ng-container *ngIf="!keepYourSecrets">
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <div *ngIf="row.consolidated && !ongoingMonth(row.month)" fxLayoutAlign="center center" fxLayoutGap="8px" class="consolidated">
                                <app-icon name="fal-check-circle" class="consolidated-icon"></app-icon>
                                <div class="txt-b-12-4 chip-text" fxLayoutAlign="center">{{ 'Consolidated'|i18n }}</div>
                            </div>
                            <div *ngIf="!row.consolidated && !ongoingMonth(row.month)"  fxLayoutAlign="center center" fxLayoutGap="8px" class="non-consolidated">
                                <app-icon name="fal-tachometer-alt-fast" class="non-consolidated-icon"></app-icon>
                                <div class="txt-b-12-4 chip-text" fxLayoutAlign="center">{{ 'Non consolidated'|i18n }}</div>
                            </div>
                            <div *ngIf="ongoingMonth(row.month)"  fxLayoutAlign="center center" fxLayoutGap="8px" class="ongoing">
                                <app-icon name="fal-clock" class="ongoing-icon"></app-icon>
                                <div class="txt-b-12-4 chip-text" fxLayoutAlign="center">{{ 'Ongoing'|i18n }}</div>
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="keepYourSecrets" fxLayoutAlign="center center" class="txt-h-12-4">{{ '-' }}</div>
                </td>
                <th mat-header-cell *matFooterCellDef></th>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="TABLE_COLUMNS"></tr>
            <tr mat-row *matRowDef="let row; columns: TABLE_COLUMNS;" class="app-row app-border-upper-row"></tr>
            <tr mat-footer-row *matFooterRowDef="TABLE_COLUMNS"></tr>

        </table>


        <!-- confirm button: currently hidden -->
<!--        <div fxLayout="row" fxFlex="20" fxLayoutAlign="end center" class="mt-30">-->
<!--            <button *ngIf="summary" app-primary-button class="mr-10" (click)="onConfirmStatus()"-->
<!--                    [disabled]="isConfirmDisabled">-->
<!--                <app-icon class="excel-icon" name="fal-file-excel"></app-icon>-->
<!--                {{ 'Confirm status_{payment}'|i18n }}-->
<!--            </button>-->
<!--        </div>-->
    </div>
    <!-- end of table section -->

    <!-- chart section -->
    <div fxLayout="row" *ngIf="summary">

        <!-- revenue breakdown charts -->
        <div fxLayout="column" class="tile-background" fxFlex="24">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" class="mb-40 txt-h-20-7">
                <div>{{'Revenue breakdown'|i18n}}</div>
                <app-icon *ngIf="summary && communityNotConfigured" icon-color-w name="fas-exclamation-triangle"
                          [title]="'Please make sure that community costs, plants withdrawal quote and plants tip quote are configured'|i18n">
                </app-icon>
            </div>
            <apx-chart
                    [series]="incentivesAndAbsorptionsChart.series"
                    [labels]="incentivesAndAbsorptionsChart.labels"
                    [chart]="incentivesAndAbsorptionsChart.chart"
                    [legend]="incentivesAndAbsorptionsChart.apexLegends"
                    [title]="incentivesAndAbsorptionsChart.title"
                    [colors]="incentivesAndAbsorptionsChart.colors"
                    [dataLabels]="incentivesAndAbsorptionsChart.dataLabels"
                    [plotOptions]="incentivesAndAbsorptionsChart.plotOptions"
                    [tooltip]="incentivesAndAbsorptionsChart.tooltip">
            </apx-chart>
            <apx-chart
                    [series]="expensesAndRevenueChart.series"
                    [labels]="expensesAndRevenueChart.labels"
                    [chart]="expensesAndRevenueChart.chart"
                    [legend]="expensesAndRevenueChart.apexLegends"
                    [title]="expensesAndRevenueChart.title"
                    [colors]="expensesAndRevenueChart.colors"
                    [dataLabels]="expensesAndRevenueChart.dataLabels"
                    [plotOptions]="expensesAndRevenueChart.plotOptions"
                    [tooltip]="expensesAndRevenueChart.tooltip">
            </apx-chart>
        </div>
        <div fxFlex></div>

        <!-- revenue distribution chart -->
        <div fxLayout="column" class="tile-background" fxFlex="24">
            <div class="mb-40 txt-h-20-7">{{ 'Net revenue distribution'|i18n }}</div>
            <apx-chart
                    [series]="revenueDistributionChart.series"
                    [labels]="revenueDistributionChart.labels"
                    [chart]="revenueDistributionChart.chart"
                    [legend]="revenueDistributionChart.apexLegends"
                    [title]="revenueDistributionChart.title"
                    [colors]="revenueDistributionChart.colors"
                    [dataLabels]="revenueDistributionChart.dataLabels"
                    [plotOptions]="revenueDistributionChart.plotOptions"
                    [tooltip]="revenueDistributionChart.tooltip">
            </apx-chart>
        </div>
        <div fxFlex></div>

        <!-- consumers members redistribution chart -->
        <div fxLayout="column" class="tile-background" fxFlex="24">
            <div class="mb-40 txt-h-20-7">{{ 'Consumers members redistribution'|i18n }}</div>
            <apx-chart
                    [series]="membersRedistributionChart.series"
                    [labels]="membersRedistributionChart.labels"
                    [chart]="membersRedistributionChart.chart"
                    [legend]="membersRedistributionChart.apexLegends"
                    [title]="membersRedistributionChart.title"
                    [colors]="membersRedistributionChart.colors"
                    [dataLabels]="membersRedistributionChart.dataLabels"
                    [plotOptions]="membersRedistributionChart.plotOptions"
                    [tooltip]="membersRedistributionChart.tooltip">
            </apx-chart>
            <div class="txt-s-14-4">{{ 'The amount is for the absorption activity only.'|i18n }}</div>
        </div>
        <div fxFlex></div>

        <!-- sharing charts -->
        <div fxLayout="column" class="tile-background" fxFlex="24">
            <div class="mb-30 txt-h-20-7">{{ 'Sharing over the period'|i18n }}</div>
            <div class="txt-s-14-4 mb-30">{{ 'Percentage of shared energy compared to total injection and absorption.'|i18n }}</div>
            <div fxLayout="row">
                <apx-chart
                        [series]="sharedFromAbsorption.series"
                        [chart]="sharedFromAbsorption.chart"
                        [legend]="sharedFromAbsorption.apexLegends"
                        [labels]="sharedFromAbsorption.labels"
                        [colors]="sharedFromAbsorption.colors"
                        [dataLabels]="sharedFromAbsorption.dataLabels"
                        [plotOptions]="sharedFromAbsorption.plotOptions"
                        [tooltip]="sharedFromAbsorption.tooltip"
                        fxFlex="25">
                </apx-chart>
                <div fxFlex="5"></div>
                <div class="txt-s-14-4 mt-20" fxFlex>
                    {{ '{0} of the absorbed energy from utilities has become shared energy.'|i18n:(summary.absorption_share_score * 100|niceValue:'%':2) }}
                </div>
            </div>
            <div fxLayout="row">
                <apx-chart
                        [series]="sharedFromInjection.series"
                        [chart]="sharedFromInjection.chart"
                        [legend]="sharedFromInjection.apexLegends"
                        [labels]="sharedFromInjection.labels"
                        [colors]="sharedFromInjection.colors"
                        [dataLabels]="sharedFromInjection.dataLabels"
                        [plotOptions]="sharedFromInjection.plotOptions"
                        [tooltip]="sharedFromInjection.tooltip"
                        fxFlex="25">
                </apx-chart>
                <div fxFlex="5"></div>
                <div class="txt-s-14-4 mt-20" fxFlex>
                    {{ '{0} of the plants injected energy has become shared energy.'|i18n:(summary.injection_share_score * 100|niceValue:'%':2) }}
                </div>
            </div>
        </div>
    </div>
    <!-- end of chart section -->

    <!-- excel file export button-->
    <!--    <div fxLayout="row" fxFlex="20" fxLayoutAlign="end center" class="mt-30">-->
    <!--        <button *ngIf="summary" app-ghost-button class="mr-10" (click)="exportEconomicsToExcel()"-->
    <!--                [disabled]="templateIsDownloading">-->
    <!--            <app-icon class="excel-icon" name="fal-file-excel"></app-icon>-->
    <!--            {{ 'Export to Excel'|i18n }}-->
    <!--        </button>-->
    <!--    </div>-->
</div>

<!-- loading spinner -->
<ng-template #loading>
    <div fxLayout="column" fxLayoutAlign="space-around center">
        <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16">
            <mat-spinner app-spinner diameter="20"></mat-spinner>
            <span class="pl-8">{{ 'Loading'|i18n }}...</span>
        </div>
        <div *ngIf="showComputationWarning" fxLayout="row" fxLayoutAlign="center center"
             fxLayoutGap="30px" economics-warning class="mt-30 padding-14">
            <app-icon icon-color-w name="fas-info-circle"></app-icon>
            <div>{{ 'We are recalculating the economics data due to an updated configuration parameter.'|i18n }}</div>
        </div>
    </div>
</ng-template>

<!-- unviewable entity warning -->
<ng-template #unviewableEntity>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-16">
        {{ 'Insufficient permissions to view this resource'|i18n }}
    </div>
</ng-template>

<!-- ec waiting for approval info -->
<ng-template #ecWaitingForApproval>
    <div fxLayout="column" class="p-30" fxLayoutAlign="center center">
        <div class="txt-h-24-7">{{ 'Community waiting for activation'|i18n }}</div>
        <app-icon icon-color-h name="fal-clock" fxFlex="60" class="clock-icon mt-30 mb-30"></app-icon>
        <ng-container *ngIf="inactiveEc">
            <div class="txt-s-16-4">{{ 'This community has no activation date yet.'|i18n }}</div>
            <div class="txt-s-16-4">{{ 'As soon as the community is activated, you will see economic and energy data here.'|i18n }}</div>
        </ng-container>
        <ng-container *ngIf="!inactiveEc">
            <div class="txt-s-16-4">{{ 'This community will be activated by {0}.'|i18n:(billingPeriodCfg.pastDate|i18nDate) }}</div>
            <div class="txt-s-16-4">{{ 'Economic data will be available from that day.'|i18n }}</div>
        </ng-container>
        <div mat-dialog-actions class="dialog-actions mt-30">
            <button app-primary-button [mat-dialog-close]="true">
                {{ 'Ok'|i18n }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #confirmStatus let-data>
    <div fxLayout="column" fxLayoutAlign="center center" class="p-100">
        <span class="txt-h-24-7">{{ 'Do you confirm the "paid" status of the selected months?'|i18n }}</span>
        <span class="txt-a-24-7 mt-48">{{ 'Warning: this action cannot be undone'|i18n }}</span>
        <span class="txt-p-16-4 mt-24">{{ 'The parameters you entered will be stored and they will be available in read-only mode.'|i18n }}</span>
        <div fxLayout="row" fxLayoutGap="40px" mat-dialog-actions class="dialog-actions mt-48">
            <button app-ghost-button [mat-dialog-close]="false">
                {{ 'Cancel'|i18n }}
            </button>
            <button app-primary-button [mat-dialog-close]="true">
                {{ 'Confirm'|i18n }}
            </button>
        </div>
    </div>
</ng-template>
